import { NgModule } from '@angular/core';
import { NgxGooglePlaceAutocompleteDirective } from './ngx-google-place-autocomplete.directive';

@NgModule({
    declarations: [NgxGooglePlaceAutocompleteDirective],
    exports: [NgxGooglePlaceAutocompleteDirective]
})
export class NgxGooglePlaceAutocompleteModule {}
